'use client'

import { useParams } from 'next/navigation'

import { contractQueries } from '@/entities/contract'
import { usePrefetchQuery } from '@/shared/api'
import { useDialog } from '@/shared/lib'
import { Button, Dialog, Icon, TextButton } from '@/shared/ui'

import { RefundCard } from './refund-card'

export const DIALOG = {
  REFUND_CARD: 'REFUND_CARD',
} as const

export const ShowRefundCardButton = () => {
  const params = useParams()

  const contractId = Number(params?.contractId)

  const { isOpen, open, closeHandler } = useDialog()

  const { prefetch } = usePrefetchQuery()

  const handleClick = async () => {
    if (!contractId) {
      return
    }

    const { success } = await prefetch(
      contractQueries.guestRefundCard({ contractId }),
    )

    if (!success) {
      return
    }

    open(DIALOG.REFUND_CARD)
  }

  return (
    <>
      <TextButton
        size="small"
        weight="normal"
        color="purple"
        onClick={handleClick}
      >
        환불 정보 확인하기
        <Icon name="arrow-right" />
      </TextButton>

      <Dialog.Root
        open={isOpen(DIALOG.REFUND_CARD)}
        onOpenChange={closeHandler(DIALOG.REFUND_CARD)}
      >
        <Dialog.Content className="h-[362px] gap-0 p-0">
          <Dialog.Header className="p-6">
            <Dialog.Title className="text-start">환불 정보</Dialog.Title>
          </Dialog.Header>
          <RefundCard contractId={contractId} />
          <Dialog.Footer className="p-6">
            <Dialog.Close asChild>
              <Button
                type="button"
                variant="solid"
                color="secondary"
                size="large"
                fullWidth
              >
                닫기
              </Button>
            </Dialog.Close>
          </Dialog.Footer>
        </Dialog.Content>
      </Dialog.Root>
    </>
  )
}
